import { render, staticRenderFns } from "./ConsultationFeeTab.vue?vue&type=template&id=dd318cc4&scoped=true&"
import script from "./ConsultationFeeTab.vue?vue&type=script&lang=js&"
export * from "./ConsultationFeeTab.vue?vue&type=script&lang=js&"
import style0 from "./ConsultationFeeTab.vue?vue&type=style&index=0&id=dd318cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd318cc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
